module.exports = __webpack_public_path__ + "img/bandera_galicia.d238d7d6.svg";